import { Plus, X } from 'lucide-react'
import MemberSearchDropdown from '../ui/MemberSearchDropdown'
import { getInitials } from './cardDetailUtils'

export default function CardMembersPanel({
    t,
    members,
    canManageMembers,
    availableMembers,
    addingMember,
    onStartAddMember,
    onCancelAddMember,
    onAddMember,
    onRemoveMemberRequest,
}) {
    return (
        <div className="card-detail-sidebar-section">
            <h4 className="cd-sidebar-heading">
                {t('card.tabs.members')} {members.length > 0 && `(${members.length})`}
            </h4>
            {members.length === 0 ? (
                <p className="cd-members-hint">{t('card.members.emptyAssigned')}</p>
            ) : (
                <div className="detail-assignees">
                    {members.map((member, index) => (
                        <div key={member.id} className="detail-assignee">
                            <div
                                className="detail-assignee-avatar"
                                style={{ background: `hsl(${(index * 71 + 200) % 360}, 50%, 40%)` }}
                            >
                                {getInitials(member.full_name)}
                            </div>
                            <div className="detail-assignee-info">
                                <div className="detail-assignee-name">{member.full_name}</div>
                            </div>
                            {canManageMembers && (
                                <button
                                    type="button"
                                    className="checklist-item-delete"
                                    onClick={() => onRemoveMemberRequest(member)}
                                    title={t('card.members.removeTooltip')}
                                >
                                    <X size={12} />
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
            {canManageMembers && availableMembers.length > 0 && (
                <div className="cd-members-add">
                    {addingMember ? (
                        <MemberSearchDropdown
                            members={availableMembers}
                            onSelect={onAddMember}
                            onClose={onCancelAddMember}
                        />
                    ) : (
                        <button className="btn btn-secondary btn-sm" onClick={onStartAddMember}>
                            <Plus size={13} /> {t('card.members.add')}
                        </button>
                    )}
                </div>
            )}
        </div>
    )
}
